export default {
  name: `rotate_screen`,
  icon: require(`@/assets/icons/rotate_screen.svg`),
};
